import { BasicLeadForm } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { List, ProgressButton } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export class LeadFormCsok extends BasicLeadForm {
	public static defaultProps = {
		...BasicLeadForm.defaultProps,
		title: "Add meg az elérhetőséged és megmutatjuk:",
		button: "Érdekelnek a részletek",
	};

	protected renderContent(): ReactNode {
		const { title, button, submitState } = this.props;

		return (
			<>
				<Card.Header>
					<Card.Title>{title}</Card.Title>
				</Card.Header>
				<Card.Body>
					<List itemStyle="info-circle">
						<List.Item>Hogyan igényelheted a támogatást?</List.Item>
						<List.Item>Mennyi idő alatt juthatsz hozzá?</List.Item>
						<List.Item>Milyen apróságokra kell odafigyelned?</List.Item>
					</List>
					{this.renderFields()}
					{this.renderPrivacyStatement()}
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton type="submit" variant="gold" size="lg" state={submitState}>
						{button}
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadFormCsok`;
	}
}
